import Animate from "./animate";
import MainMenu from "./menu/menu-main";
import WinterManager from "./extensions/wintermanager";

/**
 * lib of all helper functions and predefines
 */
export default class siteConfig {
    constructor() {
        this.activateGlobalJS();
        this.debug = window.location.hostname === "typo3.2024.ferienregion-nationalpark.de.ddev.site" ? true : false;
        this.menu = new MainMenu("#menu-main", false);
        this.animations = [".frame-animate-1", ".frame-animate-2", ".frame-animate-3", ".frame-animate-4"];
        // hide loading
        setTimeout(() => {
            $('#loadingOverlay').fadeOut();
            // hide translation plugin on mobile subpages
            this.hideTranslationSelectOnMobileSubpages();
        }, 150);
        /* check and run wintermanager if found */
        document.getElementById("gs_wintermanager") ? new WinterManager(document.getElementById("gs_wintermanager"), 200) : null;
        // init news
        this.initNewsLoadmore()
        this.initAnimations(this.animations);
        // helper functions
        return true;
    }

    activateGlobalJS() {
        document.documentElement.classList.remove("no-js");
    }

    setSearchResultText() {
        try {
            var result = document.querySelector("#kesearch_num_results");
            // remove ":" from ke_search result-text
            result.innerText = result.innerText.split(":")[0];
        } catch (error) { }
    }

    configureVideos() {
        let _t = this;
        var vids = document.querySelectorAll(".video-embed-item");
        vids.forEach(video => {
            try {
                /* disable controls of video and set the rest - hide errors */
                video.removeAttribute("controls");
                video.setAttribute("autoplay", "");
                video.setAttribute("loop", "");
                video.setAttribute("muted", "");
                video.setAttribute("playsinline", "");
            } catch (error) {
                console.debug("Error at function 'configureVideo'")
            }
        });
    }

    initSearch() {
        try {
            /* get searchfield and search-buttons */
            let _t = this;
            let searchfield = document.querySelector(".searchfield.fullscreen"), searchfieldOverlay = document.querySelector(".searchfield.fullscreen > .bg-dark");
            var searchButtons = document.querySelectorAll("#header .btn-search, #menuMobile .btn-search");
            /* show searchOverlay, if any btn-search is clicked */
            searchButtons.forEach(btn => {
                btn.addEventListener("click", function (e) {
                    // no linking on btn-search buttons (only opens overlay)
                    e.preventDefault();
                    // close main menu (mobile) if open, so it doesn't cover the search
                    if (_t.menu?.menu && _t.menu.menu.classList.contains(_t.menu.openClass)) {
                        _t.menu.mobileOpenButton?.classList.remove(_t.menu.openClass);
                        _t.menu.closeMenu();
                    }
                    if (searchfield.classList.contains("hidden")) { searchfield.classList.remove("hidden") }
                })
            });
            /* on click on bg - close search-fullscreen */
            searchfieldOverlay.addEventListener("click", function (e) {
                var overlayParent = document.querySelector("#searchfield-main")
                if (!overlayParent.classList.contains("hidden")) {
                    overlayParent.classList.add("hidden");
                }
            });
        } catch (error) {
            debug ? console.debug("ERROR: ", error) : undefined;
        }
    }

    bindEscape() {
        let _t = this;
        /* listen for input event: "push escape" to exit act elem */
        document.onkeydown = function (evt) {
            if (evt.key == "Escape") {
                try {
                    /* console.log("ALARM") */
                    _t.closeSearch();
                } catch (error) { /* dont care about errors */ }
            }
        }
    }

    closeSearch() {
        let _t = this;
        var hiddenClass = "hidden";
        let searchfield = document.querySelector(".searchfield.fullscreen");
        if (!searchfield.classList.contains(hiddenClass)) {
            searchfield.classList.add(hiddenClass);
        }
    }

    resizeIFrames(cls) {
        let _t = this;
        if (cls) {
            var frame = $(cls);
        } else {
            var frame = $("#main iframe.video-embed-item");
        }

        frame.each(function (e) {
            frame[0].height = frame[0].offsetWidth * 0.5625;
        })
    }

    /**
     * fills custom paginate Indexes of swiper
     * @param {Int} starting - index of first element
     */
    fillPaginatateIndex(starting) {
        let _t = this;
        var pagination = document.querySelectorAll(".swiper-pagination");

        pagination.forEach(paginate => {
            let id = paginate.id;
            var pog = document.querySelectorAll("#" + id + " > .swiper-pagination-bullet"), idx = starting;
            pog.forEach(p => {
                idx < 10 ? idx = "0" + idx : idx = idx;
                p.innerText = idx;
                p.ariaLabel = "Springe zu Slide " + idx;
                idx++;
            });
        });
    }

    /**
     * disables the iOs calender on click on a date input field
     */
    disableIOSCalender() {
        // check for ios mobile device
        if (navigator.userAgent.match(/(iPod|iPhone|iPad)/)) {
            var dateInputs = document.querySelectorAll(".filter input[type='date']");
            dateInputs.forEach(dateInput => {
                // switch to text field
                dateInput.setAttribute("type", "text");
            });
        }
    }

    /**
     * configure newsDetail pages
     */
    newsDetail() {
        if (document.querySelector(".news .article")) {
            var article = document.querySelector(".news .article");
            var btn = article.querySelector(".news .news-backlink-wrap");
            var parent = article.parentNode;
            parent.prepend(btn);
        }
    }

    hideTranslationSelectOnMobileSubpages() {
        let element = document.querySelector("translation-select.mobileView") ? document.querySelector("translation-select.mobileView") : null;
        let uid = window.pageUid ? window.pageUid : null;
        if (element && uid) {
            if (uid !== 1) {
                element.classList.add("hidden");
            }
        }
    }

    initNewsLoadmore() {
        let DBG = false,
            CONTAINER = document.querySelectorAll(".frame-type-news_newsliststicky .news .news-list-view:not(.news-list-slider)");
        if (CONTAINER) {
            DBG ? console.debug("initNewsLoadmore", CONTAINER) : '';
            let articlesPerPage = 4;
            CONTAINER.forEach(container => {
                const articles = container.querySelectorAll(".article");
                let currentVisible = 0;
                if (articles.length <= articlesPerPage) return; // Kein Button nötig,
                articles.forEach((article, index) => {
                    if (index >= articlesPerPage) { article.classList.add("hidden") } else { currentVisible++ }
                });
                const loadMoreBtn = document.createElement("button");
                loadMoreBtn.classList.add("btn", "btn-primary", "load-more");
                loadMoreBtn.innerText = "Mehr laden";
                container.appendChild(loadMoreBtn);
                loadMoreBtn.addEventListener("click", () => {
                    let newlyVisible = 0;
                    articles.forEach((article, index) => {
                        if (index >= currentVisible && newlyVisible < articlesPerPage) {
                            article.classList.remove("hidden");
                            newlyVisible++;
                        }
                    });
                    currentVisible += newlyVisible;
                    if (currentVisible >= articles.length) {
                        loadMoreBtn.disabled = true;
                        loadMoreBtn.classList.add("hidden");
                    }
                });
            });
        }
    }

    initAnimations(animations) {
        animations.forEach(animation => {
            new Animate(animation);
        });
    }
}
